function stripHtmlAndDecode(html) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  return doc.body.textContent || '';
}

// Simple truncate function that strips HTML, truncates at word boundary, then adds back basic formatting
const truncate = function(value, length, omission = '...') {
  if (!value || typeof value !== 'string') return '';

  // Decode HTML entities
  value = stripHtmlAndDecode(value);

  // Truncate at word boundary
  if (value.length <= length) {
    return value;
  }

  const truncated = value.substring(0, length);
  // Find the last space within the truncated string to avoid cutting off words
  const lastSpace = truncated.lastIndexOf(' ');
  const finalText = lastSpace > 0 ? truncated.substring(0, lastSpace) : truncated;

  return finalText + omission;
};

export default truncate;
